import React from 'react'
import { useContext } from 'react';
import { Link } from 'react-router-dom'
import { GlobalState } from '../../../GlobalState';
import { TabTitle } from '../../../util/titleChanger'
import { toast, ToastContainer } from 'react-toastify';
import ReactPaginate from 'react-paginate'
import { deleteBottleReturn } from '../../../action';
import { useEffect } from 'react';
import Loading from '../../../util/Loading';

export default function BottleReturnDashboard() {
    TabTitle("Bottle Return Dashboard");
    const state = useContext(GlobalState);
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    const [bottleReturns] = state.bottleReturnAPI.bottleReturns;

    //Import state
    const [rowPerPage] = state.bottleReturnAPI.rowPerPage;
    const [pageNumber, setPageNumber] = state.bottleReturnAPI.pageNumber;
    const [totalPages] = state.bottleReturnAPI.totalPages;
    const [setSearch] = state.bottleReturnAPI.search;
    const [callback, setCallback] = state.bottleReturnAPI.callback;

    const pageNumberHandler = (data) => {
        let newPageNumber = data.selected + 1;
        setPageNumber(newPageNumber)
    }

    const searchHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);
        setSearch(e.target.value ? e.target.value : "");
    }

    const deleteBottleReturnHandler = (id) => {
        deleteBottleReturn(id, signInUser.id, res => {
            if (res.status === 200) {
                toast.success(res.data);
                setCallback(!callback)
            } else {
                toast.error(res.data);
                setCallback(!callback)
            }
        })
    }

    const dateConverter = (date) => {
        let convertedDate = new Date(date).toISOString().slice(0, 10);
        return convertedDate
    }

    useEffect(() => { }, [rowPerPage, pageNumber, bottleReturns])
    return (
        <div className='form-container'>
            <div className="table">
                <div className="table_header">
                    <p>Bottle Return Details</p>
                    <div>
                        <input
                            type="text"
                            name="search"
                            id="search"
                            placeholder='Customer code here...'
                            onChange={(e) => searchHandler(e)}
                        />
                        <Link to='/bottle-return-form'><button className="add_new">+ Add New</button></Link>
                    </div>
                </div>

                {
                    bottleReturns.count === 0 ? <div className="loading-page-container"><Loading /></div>
                        : <div className="table_section">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Customer Name</th>
                                        <th>Product Name</th>
                                        <th>Quantity</th>
                                        <th>Return Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        bottleReturns.count > 0 ? bottleReturns.data.map(bottle => (
                                            <tr key={bottle.id}>
                                                <td>{bottle.customer.first_name + " " + bottle.customer.last_name}</td>
                                                <td>{bottle.product.name}</td>
                                                <td>{bottle.quantity}</td>
                                                <td>{dateConverter(bottle.create_at)}</td>
                                                <td>
                                                    <Link to={`/bottle-return-form/${bottle.id}`}><button><i className="uil uil-edit"></i></button></Link>
                                                    <Link to={`#`}></Link>
                                                    <button onClick={() => deleteBottleReturnHandler(bottle.id)}><i className="uil uil-trash-alt"></i></button>
                                                </td>
                                            </tr>
                                        ))
                                            : <tr>
                                                <td colSpan={4}>Can not found any purchase details.</td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                }

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={pageNumberHandler}
                    marginPagesDisplayed={2}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageLinkClassName='page-num'
                    previousLinkClassName='page-num'
                    nextLinkClassName='page-num'
                    activeLinkClassName='active-num'
                />
            </div>
            <ToastContainer />
        </div>
    )
}
